import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawRadiatorGreenModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "Radiator");

		this.name = "radiator-green";
		this.icon = svg_radiator_green;
		this.svgTextIndex = 1;
	}
}

window.customElements.define("inspx-draw-radiator-green-module", DrawRadiatorGreenModule);

const svg_radiator_green = (text) => html`
<svg width="90" height="25.000000000000007" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
 <g>
  <title>Layer 1</title>
  <rect stroke="black" fill="#00ff00" stroke-width="1px" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="0.94922" y="0.70715" width="88" height="23.89424" id="svg_4" rx="1" ry="1"/>
  <text font-weight="bold" transform="matrix(0.7750224919704861,0,0,0.8100930443673448,148.5611891442739,-137.33834780814317) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_1" y="193.49225" x="-134.31278" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000" stroke="black">${text}</text>
 </g>
</svg>`;
